import { render, staticRenderFns } from "./ProfileUpdateApproval.vue?vue&type=template&id=4df391e6&"
import script from "./ProfileUpdateApproval.vue?vue&type=script&lang=js&"
export * from "./ProfileUpdateApproval.vue?vue&type=script&lang=js&"
import style0 from "./ProfileUpdateApproval.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports